import CloudImageHistory from "./cloud-image-history.page";

export default CloudImageHistory;
